/* eslint-disable sort-keys */
import {
    AGE_EXTRACT,
    BARRELL,
    BRAND,
    COUNTRY,
    NET_VOLUME,
    PRODUCT_TYPE,
    REGION,
    STRONGNESS,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
} from 'modules/product-card/constants/characteristics';

const HEADER = [COUNTRY, REGION, STRONGNESS, NET_VOLUME, PRODUCT_TYPE, AGE_EXTRACT, BARRELL, BRAND];
const DETAILED = [TEMPERATURE_FROM, TEMPERATURE_TO];
const TABLET = [...HEADER, ...DETAILED];

export const VISKY_CHARACTERISTICS = {
    HEADER,
    DETAILED,
    TABLET,
};
